import { useState } from 'react'
import { Container, Tabs, TypoGraph } from 'components'
import { fleetFileTabs } from 'constants/status'
import strings from 'strings'
import { RiskScoreDashboard } from './partial'
import styles from './fleetFile.module.scss'

const FF = strings.FLEETFILE

/**
 * FleetFile — insurer-only risk product page. One tab for now (FleetFile Score);
 * the tab strip is here so later tabs slot in without reworking the page.
 */
const FleetFile: React.FC = () => {
  const [fleetFileTab, setFleetFileTab] = useState(0)

  const TabPanel = () => {
    switch (fleetFileTab) {
      case 0:
        return <RiskScoreDashboard />
      default:
        return <></>
    }
  }

  return (
    <Container>
      <div className={styles.pageHeader} data-testid="fleetfile-header">
        <div className={styles.pageTitle}>
          <span className={styles.pageTitleAccent} />
          <TypoGraph
            variant="h3"
            mb={0}
            content={FF.PAGE_TITLE}
            dataTestId="fleetfile-title"
          />
        </div>
        <div className={styles.pageTitleDivider} />
        <Tabs
          tabData={fleetFileTabs}
          value={fleetFileTab}
          id={fleetFileTabs[fleetFileTab].label}
          handleChange={(_e: any, val: number) => setFleetFileTab(val)}
          sxContainer={{ flex: 1, marginBottom: '-1px' }}
        />
      </div>
      <Container>
        <TabPanel />
      </Container>
    </Container>
  )
}

export default FleetFile
